// import { DataGrid ,  gridPageCountSelector,
//     gridPageSelector, GridToolbarContainer, GridToolbarExport ,
//     useGridApiContext,
//     useGridSelector} from "@mui/x-data-grid";
import {
  DataGrid, gridPageCountSelector,
  gridPageSelector, GridToolbarContainer, GridToolbarExport,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import ShareIcon from '@mui/icons-material/Share';
import CorporateShareModal from "./CorporateShareModal";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from '@mui/material/Button';
import VoucherCorpUploadModal from "./VoucherCorpUploadModal";
import { useState, useContext, useEffect } from "react";
import { SetVoucherListAtom, GetVoucherListAtom } from "../../store/voucherAtom";
import LogicContext from "../../Context/LogicContext";
import * as XLSX from 'xlsx';
import { formatCustomNumber } from "../../helpers/formatCustomNumber";



function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      color="primary"
      variant="outlined"
      shape="rounded"
      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

const TableHead = [
  { field: 'sn', headerName: 'S/N', width: 40, headerClassName: "tableHeader " },
  { field: 'Ref_No', headerName: 'Ref No', width: 80, headerClassName: "tableHeader " },
  { field: 'Voucher_Number', headerName: 'Voucher Number', width: 120, headerClassName: "tableHeader ", cellClassName:"font-bold show-cursor text-primary " },
  { field: 'Voucher_Amount', headerName: 'Amount (₦)', width: 90, headerClassName: "tableHeader " },
  { field: 'Voucher_Status_Name', headerName: 'Status', width: 90, headerClassName: "tableHeader " },
  { field: 'Reciepient_Name', headerName: 'Recipient Name', width: 110, headerClassName: "tableHeader ", cellClassName:' border-2', editable: 'text'},
  { field: 'Reciepient_Mobile_Number', headerName: 'Recipient Mobile', width: 120, headerClassName: "tableHeader", editable: 'text', cellClassName:' border-2', placeHolder:"Enter name"},
  { field: 'Reciepient_Email_Address', headerName: 'Email Address', width: 150, headerClassName: "tableHeader ", editable: 'text', cellClassName:' border-2' },
  { field: 'edit', headerName: 'Modify', width: 60, headerClassName: "tableHeader ", editable: 'text', cellClassName:' text-center text-primary font-weight-bold show-cursor'},
  { field: 'status', headerName: 'Status', width: 80, headerClassName: "tableHeader ", editable: 'text', cellClassName:' text-center text-danger font-weight-bold'},
]


const myRegex = new RegExp('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$');



function VoucherCreateTable(props) {
  const getVoucherData = GetVoucherListAtom();

  const [selectedIdList, setSelectedIdList] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  // getVoucherData?.newVoucherList
  const [editTrigger, setEditTrigger] = useState(false);
  const [triggerData, setTriggerData] = useState({});
  const setVoucherAtomData = SetVoucherListAtom();
  const logicContext = useContext(LogicContext);
  const [summary, setSummary] = useState({total:0, assigned:0, open:0, un_assigned:0 , redeemed: 0});


  useEffect(()=> {
    let un_assigned = 0;
    let redeemed = 0;
    let open = 0;
    let total = getVoucherData.newVoucherList.length;
    getVoucherData?.newVoucherList.forEach(element => {
        if(element?.Voucher_Status_Id === 3){
            un_assigned += 1;
        }
        if(element?.Voucher_Status_Id === 2){
            redeemed += 1;
        }
        if(element?.Voucher_Status_Id === 1){
            open += 1;
        }
        
    });

    setSummary({un_assigned: un_assigned, open: open, redeemed: redeemed, total: total});

// eslint-disable-next-line react-hooks/exhaustive-deps
setTableList(getVoucherData.newVoucherList);
},[getVoucherData]);



const onFilterClick = (type) => {
  if(type === 0){
    setTableList(getVoucherData.newVoucherList);
  }

  if(type === 1){
    let newList = getVoucherData.newVoucherList.filter((item)=> {
      if(item?.Voucher_Status_Id === type ){
        return  item;
      }
    } 
    );
    setTableList(newList);
  }

  if(type === 2){
    let newList = getVoucherData.newVoucherList.filter((item)=> {
      if(item?.Voucher_Status_Id === type ){
        return  item;
      }
    } 
    );
    setTableList(newList);
  }

  if(type === 3){
    let newList = getVoucherData.newVoucherList.filter((item)=> {
      if(item?.Voucher_Status_Id === type ){
        return  item;
      }
    } 
    );
    setTableList(newList);
  }

}



  const onColTypingEdit = (e) => {
    const rowIndex = Object.keys(e)

    let newList = [...getVoucherData.newVoucherList];
    const newEditable = e[Number(rowIndex)];
    let existData = newList[Number(rowIndex)];

    const keyVariableName = Object?.keys(newEditable);
    if (newEditable[keyVariableName]?.value && newEditable !== undefined) {
      let UpdatedData = { ...existData, [keyVariableName]: newEditable[keyVariableName]?.value };
      newList[Number(rowIndex)] = UpdatedData;
      setVoucherAtomData(prev => {
        return { ...prev, newVoucherList: newList };
      });
      logicContext.showToast(`${[keyVariableName]} has been updated!`, 'info');

    }

  }



  function onSelectChange(selectedList) {
    setRowSelectionModel([]);
    let temp = [];
    var selection = selectedList?.map((index) => {
       let element = tableList[index];
       temp.push(index);
      return element?.Ref_No;
    });
    setSelectedIdList(selection);
    setRowSelectionModel(temp);
  }


  function onTableCellClick(event) {
    if(event.field === 'edit'){
      setEditTrigger(true);
      setTriggerData(event.row);
    }else if(event.field === 'Voucher_Number'){
      navigator.clipboard.writeText(event?.row?.Voucher_Number).then(success => {
        logicContext.showToast(`${event?.row?.Voucher_Number} copied!`, '');

      });

      
    }else{
      setEditTrigger(false);
    }
  }


  const onFileUpload = (file) => {
    let uploadedFile = file.target.files[0];
    const fileType = file.target.files[0]?.name.split('.')[1];
    let tempUpload = [];
    if(fileType === 'csv'){

      var reader = new FileReader();
      reader.onload = function (e) {
          const csvFile = e.target.result;
          let lines = csvFile.split("\n");
          
          let newList = [...getVoucherData.newVoucherList];
     
          let tempObj = {Reciepient_Name:'', Reciepient_Mobile_Number:'', Reciepient_Email_Address:'', status:''};
          let counter = 0;
          for (let i = 0; i < lines.length; i++){
              const element = lines[i];
              if (i !== 0 && counter < newList.length ){
                tempUpload.push(counter);
                  tempObj.Reciepient_Name = element.split(',')[0] ? element.split(',')[0] : '';
                  tempObj.Reciepient_Mobile_Number = element.split(',')[1] ? element.split(',')[1]: '';
                  tempObj.Reciepient_Email_Address = element.split(',')[2] ? element.split(',')[2] :'';
                  tempObj.status = '';
                  const isValid = checkIfEmailIsValid(tempObj[tempObj.Reciepient_Email_Address]);
                  if(!isValid){
                    tempObj.status = 'Not valid';
                  }

                  if(tempObj.Reciepient_Mobile_Number?.length < 8){
                    tempObj.status = 'Not valid';
                }

                  if(tempObj.Reciepient_Name?.length < 2){
                    tempObj.status = 'Not valid';
                }
                  let storedData =   newList[counter];
                  newList[counter] = {...storedData, ...tempObj};
                  counter += 1
              }
          }
          setRowSelectionModel(tempUpload);
          let temp = [];
          for (let i = 0; i < tempUpload.length; i++ ){
              let element = tableList[i];
              temp.push(element?.Ref_No);
          }
          setSelectedIdList(temp);

          setVoucherAtomData(prev => {
            return { ...prev, newVoucherList: newList };
          });
          setTableList(newList);
       };
       reader.readAsText(uploadedFile);
       // end csv

    }else if(fileType === 'xlsx'){ // For Excel file
      var reader = new FileReader();
      reader.readAsArrayBuffer(file.target.files[0]);
      reader.onload = function (e) {
          var data = new Uint8Array(reader.result);
          var workbook = XLSX.read(data, { type: 'array' });
          var sheet = workbook.Sheets[workbook.SheetNames[0]];
          let jsonList = XLSX.utils.sheet_to_json(sheet);

          let newList = [...getVoucherData.newVoucherList];
     
          let tempObj = {Reciepient_Name:'', Reciepient_Mobile_Number:'', Reciepient_Email_Address:'', status:''};
          let counter = 0;
          for (let i = 0; i < jsonList.length; i++){
            const element = jsonList[i];
            
              if (i !== 0 && counter < newList.length){
                tempUpload.push(counter);
                tempObj.status = '';
                tempObj.Reciepient_Name = element?.name ? element?.name : '';
                tempObj.Reciepient_Mobile_Number = element?.mobile ? element?.mobile : '';
                tempObj.Reciepient_Email_Address = element?.email ? element?.email :'';
                const isValid = checkIfEmailIsValid(tempObj.Reciepient_Email_Address);
                  if(!isValid){
                    tempObj.status = 'Not valid';
                }

                if(tempObj.Reciepient_Mobile_Number?.length < 8){
                  tempObj.status = 'Not valid';
              }
                
                if(tempObj.Reciepient_Name?.length < 2){
                  tempObj.status = 'Not valid';
              }
                  let storedData =   newList[counter];
                  newList[counter] = {...storedData, ...tempObj};
                  counter += 1;
              }
          }

          let temp = [];
          for (let i = 0; i < tempUpload.length; i++ ){
              let element = tableList[i];
              temp.push(element?.Ref_No);
          }
          setSelectedIdList(temp);
          setRowSelectionModel(tempUpload);
          setVoucherAtomData(prev => {
            return { ...prev, newVoucherList: newList };
          });
          setTableList(newList);
      }
    }
}


const checkIfEmailIsValid =  (email)=> {
  let result =   myRegex.test(`${email}`);
  // return result ;
  return true ;

}


const onSubmitRecord = (data)=> {
  let status = '';
  setEditTrigger(false);
  if(data?.Ref_No){
    const isValid = checkIfEmailIsValid(data.Reciepient_Email_Address);
    if(!isValid){
      data.status = 'Not valid';
  }

  if(data.Reciepient_Mobile_Number?.length < 8){
    status = 'Not valid';
}
  
  if(data.Reciepient_Name?.length < 2){
    status = 'Not valid';
}
    let newList = [...getVoucherData.newVoucherList];
    let newData = {...data, status: status};
    newList[data.id ] = newData;
    setVoucherAtomData(prev => {
      return { ...prev, newVoucherList: newList };
    });
    setTableList(newList);
    setTriggerData({});

  }
}




const onSearchKeyChange = (eve)=> {
  const search =  eve.target.value;
  if(search.length > 2){
      let tempResult =  getVoucherData.newVoucherList?.filter((voucher)=> {
          return voucher?.Voucher_Number?.toString()?.indexOf(search?.toLowerCase()) >= 0 ||
                  voucher?.Reciepient_Mobile_Number?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 ||
                  voucher?.Reciepient_Email_Address?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0 ||
                  voucher?.Customer_Email_Address?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0  ||
                  voucher?.Voucher_Number?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0  ||
                  voucher?.Ref_No?.toString().toLowerCase()?.indexOf(search?.toLowerCase()) >= 0  
        });
        setTableList(tempResult);
  } else if(search.length < 1){
    setTableList(getVoucherData.newVoucherList);
  }
 
}





  return (
    <>
    {/* Start display */}
    <section className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full border border-gray-200 text-gray-800 py-4 bg-gray-50 rounded-lg">
  <div
    onClick={() => onFilterClick(0)}
    className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow duration-200"
  >
    <h1 className="text-center text-3xl font-bold text-blue-600">{summary.total}</h1>
    <div className="text-sm text-center text-gray-600">Total</div>
  </div>
  <div
    onClick={() => onFilterClick(1)}
    className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow duration-200"
  >
    <h1 className="text-center text-3xl font-bold text-red-600">{summary.open}</h1>
    <div className="text-sm text-center text-gray-600">Open</div>
  </div>
  <div
    onClick={() => onFilterClick(3)}
    className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow duration-200"
  >
    <h1 className="text-center text-3xl font-bold text-yellow-600">{summary.un_assigned}</h1>
    <div className="text-sm text-center text-gray-600">Unassigned</div>
  </div>
  <div
    onClick={() => onFilterClick(2)}
    className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow duration-200"
  >
    <h1 className="text-center text-3xl font-bold text-green-600">{summary.redeemed}</h1>
    <div className="text-sm text-center text-gray-600">Redeemed</div>
  </div>
</section>

<div className="flex flex-col md:flex-row justify-between items-center border-2 border-gray-200 bg-gray-100 mt-5 mb-2 p-4 rounded-lg">
  <div className="w-full md:w-1/3 mb-2 md:mb-0">
    <input
      onChange={(ev) => onSearchKeyChange(ev)}
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 text-sm"
      type="search"
      placeholder="Search..."
      aria-label="Search"
    />
  </div>
  <div className="flex items-center gap-2">
    <CorporateShareModal onSubmitRecord={onSubmitRecord} editTrigger={editTrigger} triggerData={triggerData} />
    {summary.un_assigned > 0 && (
      <>
        <VoucherCorpUploadModal newVoucherList={getVoucherData.newVoucherList} onFileUpload={onFileUpload} />
        <button
          className="flex items-center px-4 py-2 bg-blue-700 text-white text-sm font-medium rounded-lg hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-300 transition-colors duration-200"
          onClick={() => props?.shareActionButtonAll(selectedIdList)}
        >
          Assign <ShareIcon className="ml-1 w-5 h-5" />
        </button>
      </>
    )}
  </div>
</div>

<div className="mt-5">
  <div className="h-[450px] w-full">
    <DataGrid
      checkboxSelection={true}
      columns={TableHead}
      selectionModel={[...rowSelectionModel]}
      rowSelectionModel={rowSelectionModel}
      pageSize={10}
      rowsPerPageOptions={[4]}
      onRowSelectionModelChange={onSelectChange}
      onCellClick={onTableCellClick}
      rows={tableList?.length && tableList?.map((item, i) => ({
        ...item,
        edit: 'EDIT',
        id: i,
        sn: i + 1,
        Voucher_Amount: formatCustomNumber(item?.Voucher_Amount),
      }))}
      components={{
        Pagination: CustomPagination,
      }}
    />
  </div>
</div>

    </>
  );
}

export default VoucherCreateTable;